import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import './Q_VariableByTagsPanel.scss';
import { _className, ComponentSync, LL_V_L } from '@nu-art/thunderstorm-frontend/index';
import { ModuleFE_Variable } from '../../../_entity/variable/index.js';
import { sortArray } from '@nu-art/ts-common';
export class Q_VariablePanel extends ComponentSync {
    static defaultProps = {
        module: ModuleFE_Variable
    };
    deriveStateFromProps(nextProps, state) {
        // Update relevant variables
        if (nextProps.filter)
            state.variables = nextProps.module.cache.filter(nextProps.filter);
        else
            state.variables = nextProps.module.cache.allMutable();
        state.variables = sortArray(state.variables, item => item._nameInLowercase);
        return state;
    }
    renderListItems = () => {
        const variables = this.state.variables;
        const className = _className('variables-panel__panel-body');
        if (!variables.length)
            return _jsx(LL_V_L, { className: className, children: _jsx("div", { className: 'variables-panel__list-item', children: "No Variables Found..." }) });
        return _jsx(LL_V_L, { className: className, children: variables.map((_var, index) => _jsx("div", { className: 'variables-panel__list-item', children: _var.name }, index)) });
    };
    renderHeader = () => {
        const variables = this.state.variables;
        return _jsx("div", { className: 'variables-panel__header', children: `${this.props.header ?? 'Tags Variables'} (${variables.length})` });
    };
    render() {
        return _jsxs(LL_V_L, { className: 'variables-panel', children: [this.renderHeader(), this.renderListItems()] });
    }
}
//# sourceMappingURL=Q_VariablePanel.js.map